export const reletedUserConstEmail = '@tamtu.pl';
